export default function transformer(serverTableData) {
  if (!serverTableData.orderBy) {
    serverTableData.ascending = 0;
    serverTableData.orderBy = 'creationTime';
  }
  if (serverTableData.orderBy === 'dateSouhaite') {
    serverTableData.orderBy = 'datePlanification';
  }
}
